import { c as _c } from "react/compiler-runtime";
export default function FooterBottomBar() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-full h-auto md:h-14 flex items-center justify-center md:justify-start px-4 sm:px-6 md:px-10 py-3 md:py-0" style={{
      borderTop: "1px solid #80919A"
    }}><p className="text-xs sm:text-sm text-white/60 text-center md:text-right leading-7">کلیه حقوق برای وب ایده محفوظ ومتعلق به هلدینگ وب ایده می باشد.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}